import { useState } from "react";
import type { NotificationKind } from "./Portal";
import { StaffOrderManager } from "./StaffOrderManager";
import { OrderWorkflowSettings } from "./OrderWorkflowSettings";
import { StatementsPanel } from "./StatementsPanel";

type Tab = "daily" | "statements" | "workflow";

export function StaffOrdersWorkspace({ canManageWorkflow, canCreate, canCancel, canStatements, newOrderRequest, onMessage }: { canManageWorkflow: boolean; canCreate: boolean; canCancel: boolean; canStatements: boolean; newOrderRequest?: number; onMessage: (message: string, kind?: NotificationKind) => void }) {
  const [tab, setTab] = useState<Tab>("daily");
  const showTabs = canManageWorkflow || canStatements;
  return <section className="orders-workspace">
    {showTabs && <div className="section-tabs" role="tablist">
      <button type="button" role="tab" aria-selected={tab === "daily"} className={tab === "daily" ? "active" : ""} onClick={() => setTab("daily")}>All orders</button>
      {canStatements && <button type="button" role="tab" aria-selected={tab === "statements"} className={tab === "statements" ? "active" : ""} onClick={() => setTab("statements")}>Statements</button>}
      {canManageWorkflow && <button type="button" role="tab" aria-selected={tab === "workflow"} className={tab === "workflow" ? "active" : ""} onClick={() => setTab("workflow")}>Order workflow settings</button>}
    </div>}
    {tab === "daily" && <StaffOrderManager canCreate={canCreate} canCancel={canCancel} newOrderRequest={newOrderRequest} onMessage={onMessage}/>}
    {tab === "statements" && canStatements && <StatementsPanel staff onMessage={onMessage}/>}
    {tab === "workflow" && canManageWorkflow && <OrderWorkflowSettings onMessage={onMessage}/>}
  </section>;
}
